let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h4Nf7")).then(() => parcelRequire('9fywD'));